import React, { useState } from "react";
import InsightSwitcher from "./Components/InsightsSwitcher/InsightSwitcher";
import SubsCribeBanner from "./Components/SubscribeBanner/SubsCribeBanner";
import Switcher from "./Components/Switcher/Switcher";
import BlogCard from "./Components/BlogCard/BlogCard";
import FactSheetCard from "./Components/FactSheetCard/FactSheetCard";
import FactSheetCardImg from "./assets/factsheetCard.png";
import "./insigh.css";
import { useParams } from "react-router-dom";
import BlogPage from "./BlogPage";
import FactSheetPage from "./FactSheetPage";
import NewsPage from "./NewsPage";

const Renderer = () => {
  const { type } = useParams();
  switch (type) {
    case "blog":
      return <BlogPage />;
    case "factsheet":
      return <FactSheetPage />;
    case "news":
      return <NewsPage />;
  }
  return <BlogPage />;
};

const Insights = () => {
  const [activeOption, setActiveOption] = useState("Option 1");

  const options = [
    "All",
    "Compliance",
    "BCM",
    "Fraud",
    "GRC",
    "Outsourcing Risk",
  ];
  const { type } = useParams();
  return (
    <div className="insight-page-cnt">
      <InsightSwitcher />
      <SubsCribeBanner />
      <Renderer />
      {/* <Switcher
        options={options}
        current={activeOption}
        onChange={setActiveOption}
      />
      <BlogCard
        heading="Strengthening Your Outsourcing Risk Management Strategy: Tackling Extended Risk, Exit Management and Integrated Risk"
        navTo="/"
        description={[
          "As businesses deepen their reliance on third-party vendors, particularly in critical sectors like financial services, managing outsourcing risk becomes increasingly complex. Today's digital landscape requires organizations to go beyond traditional third-party risk management, addressing indirect risks and ensuring robust",
          " vendor exit management. Recent regulatory frameworks from entities like India’s Reserve Bank of India (RBI) and the EU's Digital Operational Resilience Act (DORA) emphasize the need for strengthened outsourcing risk management and operational resilience.",
        ]}
      />
      <FactSheetCard
        img={FactSheetCardImg}
        heading={
          "Gain Liability Protection From Data Breach Claims By Implementing Cybersecurity Frameworks"
        }
      /> */}
    </div>
  );
};

export default Insights;
